import React, { useState } from 'react';

import { useTypedDispatch, useTypedSelector } from '@/store/store';
import {
  getSelectedFilters,
  getStockFilterParams,
  setCarElectricEngines,
  setPage,
} from '@/store/reducers/cars-stock';
import {
  convertFilterParamsToOptionsByKey,
  handleChangeMultiSelect,
} from '@/modules/CarsStock/components/common.helpers';
import { OptionType } from '@/typings/common';
import StockMobileSidePanel from '@/components/StockMobileSidePanel';
import {
  FilterButton,
  FilterButtonWrapper,
  MobileFilterItemWrapper,
} from '@/modules/CarsStock/components/common.styles';
import StockFilterMultiSelect from '@/components/StockFilterMultiSelect';

function ElectricEnginesFilter() {
  const dispatch = useTypedDispatch();
  const stockFilterParams = useTypedSelector(getStockFilterParams);
  const selectedElectricEngines =
    useTypedSelector(getSelectedFilters).selectedParams.selectedElectricEngines;
  const [isOpened, setOpened] = useState(false);

  const electricEnginesOptions = convertFilterParamsToOptionsByKey(
    stockFilterParams,
    'electricEngines'
  );

  const handleSidePanelOpen = () => {
    setOpened(true);
  };

  const handleSidePanelClose = () => {
    setOpened(false);
  };

  const handleChangeElectricEngine = (electricEngine: OptionType) => {
    dispatch(
      setCarElectricEngines(
        handleChangeMultiSelect(electricEngine, selectedElectricEngines)
      )
    );
    dispatch(setPage(1));
  };

  const handleClearElectricEngines = () => {
    dispatch(setCarElectricEngines([]));
    dispatch(setPage(1));
  };

  return (
    <StockMobileSidePanel
      title="Количество электродвигателей"
      zIndex={10001}
      isInnerSidePanel
      isOpened={isOpened}
      onOpen={handleSidePanelOpen}
      onClose={handleSidePanelClose}
    >
      <MobileFilterItemWrapper>
        <StockFilterMultiSelect
          options={electricEnginesOptions}
          selectedOptions={selectedElectricEngines}
          onChange={handleChangeElectricEngine}
          onClear={handleClearElectricEngines}
        />
      </MobileFilterItemWrapper>

      <FilterButtonWrapper>
        <FilterButton onClick={handleSidePanelClose}>Применить</FilterButton>
      </FilterButtonWrapper>
    </StockMobileSidePanel>
  );
}

export default ElectricEnginesFilter;
